export default __webpack_public_path__ + "static/media/NoProfilePic.b4ede3b3.svg";